module.exports = __webpack_public_path__ + "static/media/meep-logo-nome.260fab44.png";